import { useCallback, useEffect, useState } from 'react';

import APIs from '../../../../api';
import { SingleSelection } from '../../../../components';
import { SelectChangeEvent } from '../../../../components/MuiGenerals';
import { useTranslation } from '../../../../hooks';
import useAgentProgramCurrency from '../../../../hooks/useAgentProgramCurrency';

interface IProps {
  label?: string;
  value: any;
  onChange: (e: SelectChangeEvent) => void;
  onClear: () => void;
}

const AgentProgramCurrencySingleSelection = (props: IProps) => {
  const { label, value, onChange, onClear } = props;

  const { tc } = useTranslation();

  const { AgentProgramCurrencyEnum } = useAgentProgramCurrency();

  return (
    <SingleSelection
      label={label || tc('phSelection', { fieldName: tc('currency') })}
      value={value && Object.keys(value).length > 0 ? JSON.stringify(value) : ''}
      clearSelect={onClear}
      onChange={onChange}
      enumData={AgentProgramCurrencyEnum}
      nameFn={(item) => item}
    />
  );
};

export default AgentProgramCurrencySingleSelection;
